const map = {
	"./apin/locales/en.json": 81073,
	"./apin/locales/pt.json": 44350,
	"./cadaval/locales/en.json": 72687,
	"./cadaval/locales/pt.json": 32528,
	"./cidadepraia/locales/en.json": 7984,
	"./cidadepraia/locales/pt.json": 74147,
	"./demo/locales/en.json": 2302,
	"./demo/locales/pt.json": 98269,
	"./fcolmeiasememoria/locales/en.json": 17023,
	"./fcolmeiasememoria/locales/pt.json": 25280,
	"./figueirodosvinhos/locales/en.json": 83136,
	"./figueirodosvinhos/locales/pt.json": 84019,
	"./loures/locales/en.json": 68673,
	"./loures/locales/pt.json": 51374,
	"./oaz/locales/en.json": 48843,
	"./oaz/locales/pt.json": 56596,
	"./oeiraseu/locales/en.json": 51200,
	"./oeiraseu/locales/pt.json": 81651,
	"./proenca/locales/en.json": 62913,
	"./proenca/locales/pt.json": 39726,
	"./rgrande/locales/en.json": 35272,
	"./rgrande/locales/pt.json": 53675,
	"./rnps/locales/en.json": 19568,
	"./rnps/locales/pt.json": 80387,
	"./sobral/locales/en.json": 90430,
	"./sobral/locales/pt.json": 70045,
	"./vcambra/locales/en.json": 85253,
	"./vcambra/locales/pt.json": 48394,
	"./vilaverde/locales/en.json": 40493,
	"./vilaverde/locales/pt.json": 20226,
	"./vvrodao/locales/en.json": 60274,
	"./vvrodao/locales/pt.json": 18985,
	"src/configuration/platforms/apin/locales/en.json": 81073,
	"src/configuration/platforms/apin/locales/pt.json": 44350,
	"src/configuration/platforms/cadaval/locales/en.json": 72687,
	"src/configuration/platforms/cadaval/locales/pt.json": 32528,
	"src/configuration/platforms/cidadepraia/locales/en.json": 7984,
	"src/configuration/platforms/cidadepraia/locales/pt.json": 74147,
	"src/configuration/platforms/demo/locales/en.json": 2302,
	"src/configuration/platforms/demo/locales/pt.json": 98269,
	"src/configuration/platforms/fcolmeiasememoria/locales/en.json": 17023,
	"src/configuration/platforms/fcolmeiasememoria/locales/pt.json": 25280,
	"src/configuration/platforms/figueirodosvinhos/locales/en.json": 83136,
	"src/configuration/platforms/figueirodosvinhos/locales/pt.json": 84019,
	"src/configuration/platforms/loures/locales/en.json": 68673,
	"src/configuration/platforms/loures/locales/pt.json": 51374,
	"src/configuration/platforms/oaz/locales/en.json": 48843,
	"src/configuration/platforms/oaz/locales/pt.json": 56596,
	"src/configuration/platforms/oeiraseu/locales/en.json": 51200,
	"src/configuration/platforms/oeiraseu/locales/pt.json": 81651,
	"src/configuration/platforms/proenca/locales/en.json": 62913,
	"src/configuration/platforms/proenca/locales/pt.json": 39726,
	"src/configuration/platforms/rgrande/locales/en.json": 35272,
	"src/configuration/platforms/rgrande/locales/pt.json": 53675,
	"src/configuration/platforms/rnps/locales/en.json": 19568,
	"src/configuration/platforms/rnps/locales/pt.json": 80387,
	"src/configuration/platforms/sobral/locales/en.json": 90430,
	"src/configuration/platforms/sobral/locales/pt.json": 70045,
	"src/configuration/platforms/vcambra/locales/en.json": 85253,
	"src/configuration/platforms/vcambra/locales/pt.json": 48394,
	"src/configuration/platforms/vilaverde/locales/en.json": 40493,
	"src/configuration/platforms/vilaverde/locales/pt.json": 20226,
	"src/configuration/platforms/vvrodao/locales/en.json": 60274,
	"src/configuration/platforms/vvrodao/locales/pt.json": 18985
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55637;